<template>
  <div class="TableOrder">
    <div>
      <phoneTable ref="phonetablechild" :partition="partition" @exportSuccess="exportSuccess" />
    </div>
  </div>
</template>
<script>
import phoneTable from "./table/phoneTable";
import _api from "@/utils/request";
export default {
  name: "TableOrder",
  props: ["partition"],
  components: { phoneTable },
  data() {
    return {};
  },
  created() {
    // _api.getNotPInspectorSelect({ scope: "00" }).then((res) => {
    //   console.log(res, "总监区域选择");
    //   this.partition = res.data;
    // });
    console.log(this.partition);
  },
  watch: {},
  methods: {
    exportExcel(code) {
      this.$refs.phonetablechild.exportExcel(code);
    },
    getParams() {
      return this.$refs.phonetablechild.getParams()
    },
    exportSuccess() {
      this.$emit('exportSuccess')
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.TableOrder {
  width: 100%;
  padding-bottom: 50px;
  min-height: 360px;
  background-color: white;
  padding: 16px;
  box-sizing: border-box;
}
</style>
